import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import logoMutualMobile from 'images/logo-only.png'
import { useResetPassFormValidation } from 'utils/customHooks/useResetPassFormValidation'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import { postToApiWithoutToken } from 'actions'
import PasswordField from '../../form/PasswordField'
import PasswordRequirements from '../../form/PasswordRequirements'
import SubmitButton from '../../form/SubmitButton'
import SecondaryButton from '../../form/SecondaryButton'
import { makeStyles, Typography, Grid, Hidden } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
   resetPassContainer: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      margin: theme.spacing(0, 2)
   },
   formTitle: {
      fontSize: '22px',
      textAlign: 'center',
      margin: theme.spacing(2, 0)
   },
   subtitle: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 14,
      letterSpacing: '-0.05px',
      color: '#9EA0A5'
   },
   logoMobile: {
      width: 100,
      alignSelf: 'center',
      marginTop: theme.spacing(2)
   },
   textContainer: {
      marginBottom: theme.spacing(2)
   },
   formFieldsContainer: {
      marginBottom: theme.spacing(5)
   }
}))

const INITIAL_RESET_PASS_FORM_STATE = {
   newPassword: '',
   confirmPassword: ''
}

const INITIAL_RESET_PASS_INVALID_STATE = {
   newPassword: { isInvalid: false, errorMessage: '' },
   confirmPassword: { isInvalid: false, errorMessage: '' }
}

function ResetPassword({ history }) {
   const classes = useStyles()

   const [formData, setFormData] = useState(INITIAL_RESET_PASS_FORM_STATE)
   const [isInvalid, setIsInvalid] = useState(INITIAL_RESET_PASS_INVALID_STATE)
   const { token } = useParams()

   const {
      setValue,
      isAnyPasswordFieldInvalid,
      showPassRequirements,
      setShowPassRequirements
   } = useResetPassFormValidation([formData, setFormData], setIsInvalid)

   function clean() {
      setFormData(INITIAL_RESET_PASS_FORM_STATE)
      setIsInvalid(INITIAL_RESET_PASS_INVALID_STATE)
      setShowPassRequirements(false)
   }

   async function _resetPassword() {
      const payload = {
         newPassword: formData.newPassword,
         confirmNewPassword: formData.confirmPassword
      }
      const url = `${process.env.REACT_APP_LOGIN_API}/users/reset-password?key=${token}`
      await postToApiWithoutToken(url, payload)
      history.push('/auth/reset-success')
   }

   const resetPassword = useApiRequest(
      _resetPassword,
      'Asignar Contraseña: Enviar'
   )

   function onSubmit(event) {
      event.preventDefault()
      if (!isAnyPasswordFieldInvalid()) {
         resetPassword()
      }
   }

   return (
      <Grid className={classes.resetPassContainer}>
         <Hidden smUp>
            <img
               src={logoMutualMobile}
               alt="Logo MutualSer"
               className={classes.logoMobile}
            />
         </Hidden>
         <Grid className={classes.textContainer}>
            <Typography className={classes.formTitle}>
               Asignar Contraseña
            </Typography>
            <Typography className={classes.subtitle}>
               Ingresa los datos solicitados para asignar tu contraseña.
            </Typography>
         </Grid>
         <form onSubmit={onSubmit}>
            <Grid className={classes.formFieldsContainer}>
               <PasswordField
                  fieldLabel="Nueva Contraseña *"
                  fieldName="newPassword"
                  formValue={formData?.newPassword}
                  handleChange={setValue}
                  fieldInvalid={isInvalid?.newPassword?.isInvalid}
                  errorMessage={
                     isInvalid?.newPassword?.isInvalid &&
                     isInvalid?.newPassword?.errorMessage
                  }
               />
               <PasswordField
                  fieldLabel="Confirma tu Contraseña *"
                  fieldName="confirmPassword"
                  formValue={formData?.confirmPassword}
                  handleChange={setValue}
                  fieldInvalid={isInvalid?.confirmPassword?.isInvalid}
                  errorMessage={
                     isInvalid?.confirmPassword?.isInvalid &&
                     isInvalid?.confirmPassword?.errorMessage
                  }
               />
               {showPassRequirements && <PasswordRequirements />}
            </Grid>
            <SecondaryButton text="LIMPIAR" onClick={clean} />
            <SubmitButton text="ASIGNAR CONTRASEÑA" />
         </form>
      </Grid>
   )
}

export default withRouter(ResetPassword)
